import { render } from "./HSTabs.vue?vue&type=template&id=087cbf86&scoped=true"
import script from "./HSTabs.vue?vue&type=script&lang=js"
export * from "./HSTabs.vue?vue&type=script&lang=js"

import "./HSTabs.vue?vue&type=style&index=0&id=087cbf86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087cbf86"]])

export default __exports__